export const EmptyNonPerformingVendor = {
    contact_Person_ID: undefined,
    vendor_Company_ID: 0,
    vendor_Company_Name: '',
    vendor_Company: {
        vendor_Company_ID: 0,
        vendor_Company_Name: '',
    },
    contact_Person_EmailID: '',
    contact_Person_Name: '',
    designation: 0,
    designation_Name: '',
    phone_No: '',
    cell_No: '',
    major_Technology: '',
    ext: '',
    add_by_User: 0
}